// @flow

// Libs
import _map from 'lodash/map'
import _camelCase from 'lodash/camelCase'
import _flatten from 'lodash/flatten'
import _flatMap from 'lodash/flatMap'

// Types
type Error = { [string]: string }
type Errors = Array<Error>

// Exports
export default function decodeBadResponse (response: mixed, errorKey?: string = 'error'): Errors {
  if (response != null) {
    if (typeof response === 'string' || typeof response === 'number') {
      return [ { [errorKey]: _camelCase(`${response}`) } ]
    } else if (Array.isArray(response)) {
      return _flatten(_map(response, function (resp: mixed): Errors {
        return decodeBadResponse(resp, errorKey)
      }))
    } else if (typeof response === 'object') {
      return _flatMap(_map(response, function (resp: mixed, key: string): Errors {
        let withKey = key
        if (key === 'non_field_errors' || key === '__all__') {
          withKey = 'error'
        }

        return decodeBadResponse(resp, withKey)
      }))
    }
  }

  return []
}
